import { useContext } from "react";
import {
  FeatureFlagsContext,
  IFeatureFlagsContext,
} from "../contexts/FeatureFlagsContext";

export const useFeatureFlags = (): IFeatureFlagsContext => {
  const context = useContext(FeatureFlagsContext);

  if (!context) {
    throw new Error(
      "useFeatureFlags must be used within a FeatureFlagsProvider",
    );
  }

  return context;
};
